import { useCallback } from 'react'
import { useAuth } from '@workos-inc/authkit-react'
import { useDispatch } from 'react-redux'
import { Logout } from 'src/constants/actionTypes'

/**
 * Ends the WorkOS session and clears the internal identity with it. AuthKit normally navigates
 * away, but the dispatch runs first so the store never keeps an identity the session no longer
 * backs — which is also what makes the next sign-in re-ask `/internal/auth/me`.
 */
export const useSignOut = () => {
  const { signOut } = useAuth()
  const dispatch = useDispatch()

  return useCallback(() => {
    dispatch(Logout.success())
    signOut()
  }, [dispatch, signOut])
}
